#import "./cartFragment.gql"

mutation createCartMutation($input: CartInput!, $lang: LanguageCode!) @inContext(language: $lang) {
  cartCreate(input: $input) {
    userErrors {
      message
      code
      field
    }
    cart {
      ...cartFragment
    }
  }
}
